import {
  Button,
  Checkbox,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';

const LinkingModal = ({ isOpen, onClose }: { isOpen: boolean, onClose: (accepted?: boolean) => void }) => {
  const [authorized, setAuthorized] = useState(false);
  const [read, setRead] = useState(false);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Accept Terms</ModalHeader>
        <ModalBody>
          <Flex direction="column" gap="1em">
            <Text>Social AI requires you to have full control of the Facebook Page or Instagram account you are connecting to.</Text>

            <Text>Make sure you have the correct permissions and that you're signed in to Facebook before proceeding.</Text>

            <Checkbox isChecked={authorized} onChange={(e) => setAuthorized(e.target.checked)} alignItems="baseline">
              I understand that GetintheLoop's Social AI will automatically post to the social media accounts I have connected.
              I authorized GetintheLoop to post to my connected social media accounts on my behalf.
            </Checkbox>

            <Checkbox isChecked={read} onChange={(e) => setRead(e.target.checked)} alignItems="baseline">
              I have read and agree to GetintheLoop's Social AI Terms & Conditions.
            </Checkbox>
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent="flex-start" pt="2em">
          <Button
            onClick={() => onClose(true)}
            colorScheme="blue"
            disabled={!authorized || !read}
          >Continue</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LinkingModal;
